import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { Text, View } from 'react-native';

interface Props {
  totalPrice?: string;
  unitCount?: number;
}

export const CreditRequestDetailPrices: React.FC<Props> = ({
  totalPrice,
  unitCount,
}) => {
  const [styles] = useStyles();
  return (
    <View style={styles.base} testID="credit-request-detail-prices">
      {unitCount ? (
        <View collapsable={false}>
          <Text style={TYPOGRAPHY.small}>{i18n.t('units')}</Text>
          <Text style={styles.columnValue}>{unitCount}</Text>
        </View>
      ) : null}
      {totalPrice ? (
        <View style={styles.column}>
          <Text style={TYPOGRAPHY.small}>{i18n.t('total')}</Text>
          <Text style={styles.columnValue}>{totalPrice}</Text>
        </View>
      ) : null}
    </View>
  );
};

const useStyles = createStyles(() => ({
  base: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginVertical: 8,
  },
  column: {
    alignItems: 'flex-end',
    marginLeft: 48,
  },
  columnValue: {
    ...FONTS.primarySemiBold,
    fontSize: 20,
    lineHeight: 24,
  },
}));
